import api from './client';

// Bridge (BNP Paribas) API
export const bridgeAPI = {
  getStatus: () => api.get('/integrations/bridge/status'),
  connect: (origin, label, entityId, bankName) => api.get('/integrations/bridge/connect', {
    params: { origin, label, ...(entityId ? { entity_id: entityId } : {}), ...(bankName ? { bank_name: bankName } : {}) },
  }),
  disconnect: (connectionId) => api.delete(`/integrations/bridge/disconnect/${connectionId}`),
  sync: (connectionId) => connectionId
    ? api.post(`/integrations/bridge/sync/${connectionId}`)
    : api.post('/integrations/bridge/sync'),
  getDiagnostics: () => api.get('/integrations/bridge/diagnostics'),
  getBalanceSanity: (days) => api.get('/admin/diagnostics/bridge-balance-sanity', { params: { days } }),
};
